export default [
  {
    path: '/user',
    name: 'Users',
    component: () => import(/* webpackChunkName: 'user' */ './views/Index.vue')
  }
]
